import text from './text'
import 'bootstrap'
import bootbox from 'bootbox'

export default function alert(message, funOk, funKo) {

  var b = bootbox.confirm({
    message: text(message),
    buttons: {
      confirm: {
        label: text('bootbox.confirm'),
        className: 'btn-primary',
      },
      cancel: {
        label: text('bootbox.cancel'),
        className: 'btn-secondary',
      },
    },
    callback: function (response) {
      if (response) {
        funOk && funOk()
      } else {
        funKo && funKo()
      }
    },
  })
  b.on('shown.bs.modal', function () {
    $('.btn-primary').blur()
  })
}
